import React from 'react';
import classNames from 'classnames';
import { ReactTable } from '../../../../shared/ReactTable';
import GA2RFValuesTableHead from './GA2RFValuesTableHead';
import GA2RFValuesTableBody from './GA2RFValuesTableBody';
import GA2RFValuesTableHeading from './GA2RFValuesTableHeading';
import styles from './GA2RFValuesTable.module.css';

function GA2RFValuesTable({ data, columns, className, lastUpdated }) {
  return (
    <div className={styles.container}>
      <ReactTable
        className={classNames(styles.root, className)}
        data={data}
        columns={columns}
        resizable={false}
        showPagination={false}
        pageSize={data.length}
        TheadComponent={GA2RFValuesTableHead}
        TbodyComponent={GA2RFValuesTableBody}
        ThComponent={GA2RFValuesTableHeading}
        getTheadThProps={(props, _rowInfo, column) => ({
          sortable: column?.sortable ?? props.sortable
        })}
      />
      <div className={styles.lastUpdated}>
        <div className={styles.lastUpdatedTitle}>Last Updated: {lastUpdated}</div>
      </div>
    </div>
  );
}

export default GA2RFValuesTable;
